var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      attrs: {
        "append-to-body": true,
        title: _vm.titleValue,
        visible: _vm.newCodeDialog,
        "custom-class": "drawerClass",
        direction: "ltr",
        size: "520px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.newCodeDialog = $event
        },
        close: _vm.handleNewCodeDialog,
      },
    },
    [
      _c(
        "div",
        { staticStyle: { padding: "0 20px" } },
        [
          _c(
            "el-form",
            {
              ref: "addFormRef",
              staticClass: "search-form",
              attrs: {
                inline: false,
                model: _vm.addForm,
                rules: _vm.rules,
                "label-position": "top",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("home.onDutyDate"),
                            prop: "workDate",
                          },
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "picker-options": _vm.pickerOptions,
                              placeholder: _vm.$t("GlobalSetObj.pleaseChoose"),
                              type: "date",
                              "value-format": "yyyy-MM-dd",
                            },
                            model: {
                              value: _vm.addForm.workDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "workDate", $$v)
                              },
                              expression: "addForm.workDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("home.selectPosition"),
                            prop: "position",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                placeholder: _vm.$t(
                                  "GlobalSetObj.pleaseChoose"
                                ),
                                clearable: "",
                                "collapse-tags": "",
                                filterable: "",
                              },
                              on: { change: _vm.handlePosition },
                              model: {
                                value: _vm.addForm.position,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addForm, "position", $$v)
                                },
                                expression: "addForm.position",
                              },
                            },
                            _vm._l(_vm.positionList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.addForm.position === 2
                    ? _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t(
                                  "collectionCenter.transferCenter"
                                ),
                                prop: "departmentId",
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: _vm.$t(
                                      "GlobalSetObj.pleaseChoose"
                                    ),
                                    clearable: "",
                                    "collapse-tags": "",
                                    filterable: "",
                                  },
                                  model: {
                                    value: _vm.addForm.departmentId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.addForm, "departmentId", $$v)
                                    },
                                    expression: "addForm.departmentId",
                                  },
                                },
                                _vm._l(_vm.TransferList, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: { label: item.name, value: item.id },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            label: _vm.$t("home.onDutyCount"),
                            prop: "staffCount",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t("userManage.pleaseInput"),
                              clearable: "",
                              maxlength: "5",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.addForm.staffCount,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "staffCount", _vm._n($$v))
                              },
                              expression: "addForm.staffCount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-col", { attrs: { span: 24 } }, [
                    _c(
                      "div",
                      { staticStyle: { float: "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: { click: _vm.submitForm },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("GlobalSetObj.determine")) + " "
                            ),
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.handleNewCodeDialog },
                          },
                          [_vm._v(_vm._s(_vm.$t("GlobalSetObj.cancel")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }